import React from "react";
import { NavLink } from "react-router-dom";

import "./styles.scss";

export default class NavigationLink extends React.Component {
  render() {
    var linkText = this.props.linkText;
    var to = this.props.to;
    return (
      <div className="navLink">
        <NavLink activeClassName="--active" to={to} exact>
          {linkText}
        </NavLink>
      </div>
    );
  }
}
